import { Form, FormInstance, Input, InputNumber } from "antd";
import React, { ChangeEvent, useRef } from "react";

import "./FormItemInputNumber.scss";

interface FormItemInputNumberProps {
  name: string | (string | number)[];
  placeholder?: string;
  label: string;
  rules: { required: boolean; message?: string };
  defaultValue?: string;
  disabled?: boolean;
  prefix?: string;
  maxLength?: number;
}

const FormItemInputNumber: React.FC<FormItemInputNumberProps> = ({
  name,
  placeholder,
  rules,
  label,
  defaultValue,
  disabled,
  prefix,
  maxLength,
}) => {
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const keyCode = event.keyCode || event.which;

    if ((keyCode < 48 || keyCode > 57) && [8, 46, 37, 39].indexOf(keyCode) === -1) {
      event.preventDefault();
    }
  };

  return (
    <Form.Item
      className={`form-item__input`}
      name={name}
      label={label}
      rules={[{ required: rules.required, message: rules.message }]}
    >
      <InputNumber
        className={"input"}
        prefix={prefix ? <img src={prefix} alt={"prefix"} /> : null}
        placeholder={placeholder}
        defaultValue={defaultValue}
        disabled={disabled}
        maxLength={maxLength}
        controls={false}
        onKeyPress={handleKeyPress}
      />
    </Form.Item>
  );
};

export default FormItemInputNumber;
